import Vue from 'vue'
import Router from 'vue-router'
import store from "../store";

// import TaskManagement from '../views/tms/MainView.vue'
// import TaskDocuments from '../views/tms/TaskDocuments.vue'
// import Tasks from '../views/tms/Tasks.vue'
// import TaskDashboard from '../views/tms/TaskDashboard.vue'
import Login from '../views/Login.vue'
import InboxView from '../views/InboxView.vue'
import SignedView from '../views/SignedView.vue'
import DocumentDetailView from '../views/DocumentDetailView.vue'
import ProfileView from "../views/ProfileView.vue";
import ExDocSignView from "../views/ExDocSignView.vue";




import constants from '@/assets/js/constants';
import axios from 'axios';
Vue.use(Router)

var appRoutes = [
  {
    path: "/",
    redirect: () => {
      const user = localStorage.getItem("user");
      return user ? "/inbox" : "/login";
    }
  },
  {
    path: "/inbox",
    name: "inbox",
    component: InboxView,
    meta: { customData: { permissionName: "*" } },
  },
  {
    path: "/ExDocSign",
    name: "ExDocSign",
    component: ExDocSignView,
    meta: { customData: { permissionName: "*" } },
  },
  {
    path: "/profile",
    name: "profile",
    component: ProfileView,
    meta: { customData: { permissionName: "*" } },
  },
  {
    path: "/signed",
    name: "signed",
    component: SignedView,
    meta: { customData: { permissionName: "signed" } },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
];

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: appRoutes,
});

router.beforeEach(async (to, from, next) => {
	next();
});

export default router